/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DatasetBillingProviderViewModel {
  billingProviderLastOrgName?: string | null;
  billingProviderFirstName?: string | null;
  billingProviderMiddleName?: string | null;
  billingProviderSuffix?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  stateCode?: string | null;
  zip?: string | null;
  box33AValue?: string | null;
  box33BValue?: string | null;
  box33BType?: string | null;
  personEntity?: boolean;
  box25Qualifier?: string | null;
  taxIdNumber?: string | null;
  stateLicenseNumber?: string | null;
  deptOfLaborProviderId?: string | null;
  mailingAddress1?: string | null;
  mailingAddress2?: string | null;
  mailingCity?: string | null;
  mailingStateCode?: string | null;
  mailingZip?: string | null;
  taxonomy?: string | null;
  npi?: string | null;
  phoneNumber?: string | null;
  haveBox33Rule?: boolean;
  imaginePayRefundPaymentCodeId?: string | null;
}
